/*
 * Sort array of objects based on another array
 *
 * Example:
 * Given an "order" of: ["a", "b", "c"]
 * and an "array" of:   ["b", "d", "a", "c", "e", "f"]
 * it returns:          ["a", "b", "c", "d", "e", "f"]
 */
export function sortBasedInOtherArray<T extends number | string>(
  order: T[],
  array: T[]
) {
  array.sort(function (a, b) {
    const indexA = order.indexOf(a);
    const indexB = order.indexOf(b);

    if (indexA < 0) {
      return 1;
    }

    if (indexB < 0) {
      return -1;
    }

    if (indexA < indexB) {
      return -1;
    }

    return 1;
  });

  return array;
}
